import { Lock } from "lucide-react";

export function LockBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-800">
      <Lock className="h-3 w-3" /> Locked
    </span>
  );
}
